import { useEffect, useRef, useState } from "react";
import { useDispatch } from 'react-redux';
import { addHoldingPackageByBags, handleReturnedBlockBatch} from '../../../actions/hpmAction';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { getUserPreference } from "../../../utilities/common";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { Button, CircularProgress } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    total: {
        display: 'flex',
        flexDirection: 'column'
    },
    root: {
        display: 'flex',
        width: '100%',
        alignItems: 'center'
    },
    container: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        marginTop: 20
    },
    textFieldStyle: {
        width: '60%',
        marginRight: 10
    },
    buttonStyle: {
        width: '30%',
        marginRight: 10
    }
}));

function AddHoldingByBags(props) {
    const classes = useStyles();
    const {t} = useTranslation('holdingPackagesManagement');
    const dispatch = useDispatch();
    let userPref = getUserPreference();

    const [blockBags, setBlockBags] = useState('');
    const [disable, setDisable] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resAdded, setResAdded] = useState([]);
    const [resFailed, setResFailed] = useState([]);

    const handleBlockBagsInput = (event) => {
        if(event.target.value) {
            setDisable(false);
        } else {
            setDisable(true);
        }
        let blockBagsCurr = event.target.value.replace(/\s/g, '');
        setBlockBags(blockBagsCurr);
    };

    useEffect(() => {
        if(props.openComponent) {
            setDisable(true);
        }
    }, [props.openComponent])

    return (
        <div className={classes.total}>
            <div className={classes.root}>
                <TextField
                    placeholder={t('input_block_bags')}
                    onChange={handleBlockBagsInput}
                    rows={10}
                    variant="outlined"
                    className={classes.textFieldStyle}
                />
                <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={handleAddByBags}
                    className={classes.buttonStyle}
                    disabled={disable}
                >
                    {t('add_by_bags')}
                </Button>
                {
                    loading &&
                    <div style={{ width: '5%', verticalAlign: 'center'}}>
                        <CircularProgress color='secondary'/>
                    </div>
                }
            </div>
        </div>
    );

    function handleAddByBags() {
        console.log(props.detainedReason)
        if(blockBags.substring(blockBags.length-1, blockBags.length) === ',') {
            dispatch(showAlertSnackbar({message: 'Please check input format!', type: 'error'}))
        } else {
            setDisable(true);
            setLoading(true);
            dispatch(addHoldingPackageByBags(blockBags, userPref.userCity,props.detainedReason))
            .then((res) => {
                dispatch(handleReturnedBlockBatch(res.add_result.block_batch))
                setResAdded(res.udpated);
                setResFailed(res.add_result.failed_tnos);
                dispatch(showAlertSnackbar({message: 'Updated: ' + res.updated + ', ' + "Failed: " + res.add_result.total_failed, type: 'success'}))
                setDisable(false);
                setLoading(false);
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
                setDisable(false);
                setLoading(false);
            })
        }
    }
}

export default AddHoldingByBags;